import { render, staticRenderFns } from "./Detail-Service.vue?vue&type=template&id=85465a2a"
import script from "./Detail-Service.vue?vue&type=script&lang=js"
export * from "./Detail-Service.vue?vue&type=script&lang=js"
import style0 from "./Detail-Service.vue?vue&type=style&index=0&id=85465a2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports